$(document).ready(function ($) {


    PageScroll();


    function removeValueFromString(inputString, valueToRemove) {
        // Split the input string into an array using ","
        const valuesArray = inputString.split(',');

        // Use the filter method to remove the specified value
        const filteredArray = valuesArray.filter(item => item.trim() !== valueToRemove);

        // Join the filtered array back into a string using ","
        const resultString = filteredArray.join(',');

        return resultString;
      }





    function getAllTimelinePosts() {

        $.ajax({
            url: '/get-timeline-posts?offset=0',
            type: 'GET',
            data: {
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                $(".activity-list").html("");
                $(".activity-list").prepend(response);
            },
            error: function (error) {
                var err = JSON.parse(error.responseText);
                toastr.error(err.toastr);
            }
        });

    }

    function PageScroll() {
        $(".scroll-tiger").on("click", function (e) {
            var $anchor = $(this);
            $("html, body").stop().animate({
                scrollTop: $($anchor.attr("href")).offset().top - 0
            }, 1500, 'easeInOutExpo');
            $('.overlay-section').removeClass('active');
            e.preventDefault();

        });
    }


    // Loading Box (Preloader)
    function handlePreloader() {
        if ($('.preloader').length > 0) {
            $('.preloader').delay(200).fadeOut(500);
        }
    }

    function PageLoad() {
        $(window).on("load", function () {
            setInterval(function () {
                $('.preloader-wrap').fadeOut(300);
            }, 400);
            setInterval(function () {
                $('body').addClass('loaded');
            }, 600);
        });
    }


    handlePreloader();
    PageLoad();

    $('.carousel-card').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        autoplay: false,
        dots: false,
        autoWidth: true
    })



    $('.category-card').owlCarousel({
        loop: false,
        margin: 7,
        nav: true,
        autoplay: false,
        dots: false,
        navText: ['<i class="ti-angle-left"></i>', '<i class="ti-angle-right"></i>'],
        autoWidth: true
    })

    $('.banner-slider').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        autoplay: false,
        dots: true,
        navText: ["<i class='ti-angle-left icon-nav'></i>", "<i class='ti-angle-right icon-nav'></i>"],
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1200: {
                items: 1,
            }

        }
    })

    $('.brand-slider').owlCarousel({
        loop: true,
        margin: 15,
        nav: false,
        autoplay: false,
        dots: false,
        items: 5,
        responsive: {
            0: {
                items: 2,
            },
            600: {
                items: 3,
            },
            1200: {
                items: 5,
            }

        }
    })

    $('.product-slider').owlCarousel({
        loop: true,
        margin: 3,
        // nav:true,
        // navText: ["<i class='ti-angle-left icon-nav'></i>","<i class='ti-angle-right icon-nav'></i>"],
        autoplay: true,
        dots: false,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1200: {
                items: 2,
            }

        }
    })



    $('.feedback-slider').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        autoplay: false,
        dots: false,
        items: 5,
        navText: ['<i class="ti-angle-left"></i>', '<i class="ti-angle-right"></i>'],
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1200: {
                items: 3,
            }

        }
    })
    $('.feedback-slider2').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        autoplay: false,
        dots: false,
        items: 5,
        navText: ['<i class="ti-angle-left"></i>', '<i class="ti-angle-right"></i>'],
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1200: {
                items: 2,
            }

        }
    })

    $('.story-slider').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        autoplay: true,
        dots: true,
        touchDrag: true,
        navText: ["<i class='ti-angle-left icon-nav'></i>", "<i class='ti-angle-right icon-nav'></i>"],
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1200: {
                items: 1,
            }

        }
    })

    $('.product-slider-6').owlCarousel({
        loop: true,
        margin: 15,
        nav: false,
        autoplay: false,
        dots: false,
        items: 5,
        responsive: {
            0: {
                items: 2,
            },
            600: {
                items: 3,
            },
            1200: {
                items: 6,
            }

        }
    });







    $(window).on('load', function () {
        $('#Modalstories').modal('show');
    });


    $('.emoji-bttn').on('click', function () {
        $(this).parent().find('.emoji-wrap').toggleClass('active');
        return false;
    });

    $('.add-wishlist').on('click', function () {
        $(this).toggleClass('bg-greylight bg-danger');
        $(this).find('i').toggleClass('text-grey-900 text-white')
        return false;
    });

    $('.question-div .question-ans').on('click', function () {
        $('.question-ans').removeClass('active');
        $(this).addClass('active');
        return false;
    });

    $('.question-div .question-ans').on('click', function () {
        $('.question-ans').removeClass('active');
        $(this).addClass('active');
        return false;
    });

    $('.next-bttn').on('click', function () {
        var next_bttn_id = $(this).attr('data-question');
        $('.question-div .card-body').fadeOut(0);
        $('.question-div #' + next_bttn_id).fadeIn(500);
        // alert(next_bttn_id);
        // $(this).addClass('active');
        return false;
    });



    $('.dropdown-menu-icon').on('click', function () {
        $('.dropdown-menu-settings').toggleClass('active');
    });




    $('.menu-search-icon').on('click', function () {
        $('.app-header-search').addClass('show');
    });
    $('.searchbox-close').on('click', function () {
        $('.app-header-search').removeClass('show');
    });



    $('.switchcolor').on('click', function () {
        $(this).addClass('active');
        $('.backdrop').addClass('active');
        $('.switchcolor-wrap').addClass('active');
    });

    $('.sheet-close,.backdrop').on('click', function () {
        $('.switchcolor').removeClass('active');
        $('.backdrop').removeClass('active');
        $('.switchcolor-wrap').removeClass('active');
    });

    $('#darkmodeswitch').on('change', function () {
        if (this.checked) {
            $('body').addClass('theme-dark');
        } else {
            $('body').removeClass('theme-dark');
        }
    });




    $('.chat-active-btn').on('click', function () {
        $('.right-chat').toggleClass('active-sidebar');
        $('.main-content').toggleClass('right-chat-active');
        return false;
    });

    $(window).resize(function () {
        if ($(this).width() < 1600) {
            $('.right-chat').removeClass('active-sidebar');
        }
        else {
            $('.right-chat').addClass('active-sidebar');
        }
    })

    if ($(window).width() < 1600) {
        $('.right-chat').removeClass('active-sidebar');
    }
    else {
        $('.right-chat').addClass('active-sidebar');
    }

    $(window).scroll(function () {
        if ($(this).scrollTop() > 10) {
            $('.scroll-header').addClass('bg-white shadow-xss');
        } else {
            $('.scroll-header').removeClass('bg-white shadow-xss');
        }
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 10) {
            $('.middle-sidebar-header').addClass('scroll');
        } else {
            $('.middle-sidebar-header').removeClass('scroll');
        }
    });


    $('.nav-menu').on('click', function () {
        $(this).toggleClass('active');
        $('.navigation').toggleClass('nav-active');
    });

    $('.model-popup-chat').on('click', function () {
        $('.modal-popup-chat').toggleClass('d-block');
        return false;
    });
    $('.modal-popup-chat a').on('click', function () {
        $('.modal-popup-chat').removeClass('d-block');
        return false;
    });





    $('.close-nav').on('click', function () {
        $('.navigation').removeClass('nav-active');
        return false;
    });


    $('.toggle-menu-color input').on('change', function () {
        if (this.checked) {
            $('.navigation').addClass('menu-current-color');
        } else {
            $('.navigation').removeClass('menu-current-color');
        }
    });

    $('.toggle-menu input').on('change', function () {
        if (this.checked) {
            $('.navigation,.main-content').addClass('menu-active');
        } else {
            $('.navigation,.main-content').removeClass('menu-active');
        }
    });

    $('.toggle-screen input').on('change', function () {
        if (this.checked) {
            $('body').addClass('theme-full');
        } else {
            $('body').removeClass('theme-full');
        }
    });


    $('.toggle-dark input').on('change', function () {
        if (this.checked) {
            $('body').addClass('theme-dark');
        } else {
            $('body').removeClass('theme-dark');
        }
    });

    $('input[name="color-radio"]').on('change', function () {
        if (this.checked) {
            $('body').removeClass('color-theme-teal color-theme-cadetblue color-theme-pink color-theme-deepblue color-theme-blue color-theme-red color-theme-black color-theme-gray color-theme-orange color-theme-yellow color-theme-green color-theme-white color-theme-brown color-theme-darkgreen color-theme-deeppink color-theme-darkorchid');
            $('body').addClass('color-theme-' + $(this).val());
        }
    });

    $('body').on('click', '.bb-upload-button' , function(e){
        e.preventDefault();
        let $upload_button = $(this);
        $upload_button.parent().find('.input-file').trigger('click');
    })


    $('body').on('change', '.bb-upload-field', function (e) {
        e.preventDefault();
        var   $upload_field = $(this);
        const fileName      = $upload_field[0].files[0].name;
        var   files         = $upload_field[0].files;
        var   totalfiles    = files.length;
        var   fd            = new FormData();

        for (var index = 0; index < totalfiles; index++) {
            fd.append("media[]", files[index]);
        }

        fd.append("media_type", $upload_field.attr("data-file-type"));


        $.ajax({
            url: '/media',
            type: 'POST',
            data: fd,
            contentType: false,
            processData: false,
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            beforeSend: function(){
                $upload_field.parent().find('button i').removeClass('ti-check').removeClass('ti-cloud-down').addClass('spinner-border')
            },
            success: function (response) {
                $upload_field.parent().find('button i').removeClass('spinner-border').addClass('ti-check')

                var media = response.media;
                var prop;
                var mediaIds = '';
                var mediaPreview = '';
                for (prop in media) {
                    if (!media.hasOwnProperty(prop)) continue;
                    let singleMedia = media[prop];
                    mediaIds = mediaIds ? mediaIds + ',' + singleMedia.id : singleMedia.id;
                    toastr.info(singleMedia.name + ' uploaded');
                    mediaPreview = mediaPreview + '<li><p class="file-name-preview"><span class="badge badge-dark ">' + singleMedia.name + '</span><i data-media-id="' + singleMedia.id +'" class="ti-trash large-icon me-3 d-block delete-dd-media"></i></p></li>';
                }
                if (mediaIds){
                    $upload_field.parent().find('.upload-hidden-field').val(mediaIds);
                }

                if (mediaPreview) {
                    $upload_field.parent().find('.media-preview ul').html(mediaPreview);
                }
            },
            error: function(err){
                toastr.error('Unable to upload ' + fileName);
                $upload_field.parent().find('button i').removeClass('spinner-border').addClass('ti-cloud-down')
            },
            complete: function(){

            }
        });



    })


    $('body').on('click' , '.delete-dd-media' , function(e){
        e.preventDefault();
        $deleteButton = $(this);
        let media_id = $(this).attr("data-media-id");

        console.log(media_id);
        console.log($deleteButton);

        $.ajax({
            url: '/media/' + media_id,
            type: 'DELETE',
            dataType: 'json',
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            success: function(response) {
                let previous_value = $deleteButton.closest('.bb-uploader').find('.upload-hidden-field').val();
                let updatedString = removeValueFromString(previous_value, media_id);
                $deleteButton.closest('.bb-uploader').find('.upload-hidden-field').val(updatedString);
				$deleteButton.closest('.bb-uploader').find('.file-name-preview').html(updatedString);
				 toastr.info('File deleted');
				 
            },
            error: function(xhr, textStatus, errorThrown) {
                // console.error(xhr.statusText);
            }
        });


    })


    $('body').on('click', '.password-show-hide' , function(e){
        e.preventDefault();
        const password = document.querySelector("#password");
        const type = password.getAttribute("type") === "password" ? "text" : "password";
        password.setAttribute("type", type);
        // toggle the eye icon
        $(this).toggleClass('hidden-password')
    })


    $('body').on('click', '.follow-btn', function (e) {
        e.preventDefault();
        var btn = $(this);
        var id = $(this).data('id');
        var follow = 1;
        $.ajax({
            url: '/follow-connection',
            type: 'POST',
            data: {
                id: id,
                follow: follow
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function beforeSend() {
                btn.text("......");
                //$btn.html('<i class="spinner-border small-icon me-3 d-block "></i>');
            },
            success: function success(response) {
                btn.html("");
                btn.text("Following");
                btn.removeClass('follow-btn').addClass('unfollow-btn');
            },
            error: function error(err) {

            },
            complete: function complete() { }
        });

    });


    $('body').on('click', '.unfollow-btn', function (e) {
        e.preventDefault();
        var btn = $(this);
        var id = $(this).data('id');
        var follow = 0;
        $.ajax({
            url: '/follow-connection',
            type: 'POST',
            data: {
                id: id,
                follow: follow
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function beforeSend() {
                btn.text("......");
                //$btn.html('<i class="spinner-border small-icon me-3 d-block "></i>');
            },
            success: function success(response) {
                btn.html("");
                btn.text("Follow");
                btn.removeClass('unfollow-btn').addClass('follow-btn');
            },
            error: function error(err) {

            },
            complete: function complete() { }
        });

    });


    $(".applicants").on('click', function (e) {
        e.preventDefault();
        var request_id = $(this).attr("data-id");
        $.ajax({
            url: '/applicants/' + request_id,
            type: 'GET',
            success: function (response) {
                console.log(response);
                var header = $('#workRequestHeader').data('context');
                alert(header);
                var heading = '';
                if(header){
                    heading = '('+header+')'
                }
                var myModal = new bootstrap.Modal(document.getElementById("previewModal"), {});
                myModal.show();
                $(".modal-title").html('View Applicants'+heading);
                $(".modal-body").html(response);
                $('#previewModal').appendTo("body")
            },
            error: function (error) {
                var err = JSON.parse(error.responseText);
                toastr.error(err.toastr);
            }
        });
    });

    $( document ).on("click", ".user-id", function(e){
        e.preventDefault();
        var id = $(this).attr('data-id');
        if(id){
            $.ajax({
                beforeSend:function(){
                    $('#close-modal').click();
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                url: '/get-chats/'+id,
                type: 'POST',
                data: id,
                success:function(response){
                    $('.nochats').hide();
                    $('#chatsdivider').html(response.html)
                    console.log(response);
                },
                error:function (error) {
                    console.log(error);
                },
                complete:function(){
                }

            });
        }
    });
    $('body').on('click', ".application-action", function (e) {
              e.preventDefault();
        let workrequestid = $(this).attr('data-workrequestid');
        let reasonMessage = 'applied-work-reason-' + workrequestid;
        let data_status   = $(this).attr("data-status");
        // Only show the textarea for this specific application
        $("."+reasonMessage).removeClass('d-none');
        // Hide the first action group and show the second action group only for this application
        $(this).closest('.application-action-group').find('.application-first-action-group').hide();
        $(this).closest('.application-action-group').find('.application-second-action-group').find('.application-action-submit').attr("data-status", data_status);
        $(this).closest('.application-action-group').find('.application-second-action-group').show();
    });


    $('body').on('click', ".application-action-cancel", function (e) {

        let workrequestid = $(this).attr('data-workrequestid');
        let reasonMessage = 'applied-work-reason-' + workrequestid;
        $("."+reasonMessage).addClass('d-none')
        $(this).closest('.application-action-group').find('.application-first-action-group').show()
        $(this).closest('.application-action-group').find('.application-second-action-group').find('.application-action-submit').attr("data-status", "");
        $(this).closest('.application-action-group').find('.application-second-action-group').hide()
    });


    $('body').on('click', ".application-action-submit", function (e) {
        e.preventDefault();
        let $applicationButton     = $(this);

        let company_id         = $applicationButton.attr('data-companyid');
        let work_request       = $applicationButton.attr('data-workrequestid');
        let status             = $(this).attr('data-status');
        let reasonMessageClass = 'applied-work-reason-' + work_request;
        let reason             = $("." + reasonMessageClass).val();



        var applicant = $.ajax({
            url: '/applicants-status',
            type: 'POST',
            data: {

                reason,
                company_id,
                work_request,
                status,
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function beforeSend() {
                $applicationButton.addClass("button--loading")
                $applicationButton.closest('.application-second-action-group').find(".application-action-cancel").addClass("disabled");
            },
            success: function (response) {
                if (response.success) {
                    toastr.success(response.toastr);
                } else {
                    toastr.error(response.toastr);
                }
            },
            error: function (error) {
                var err = JSON.parse(error.responseText);
                toastr.error(err.toastr);
            },
            complete:function(){
                location.reload();
            }
        });

    });

    // $('body').on('click', ".accept-applicant", function (e) {
    //     e.preventDefault();
    //     var reason = $('.reason').val();
    //     var company_id = $(this).attr('data-companyid');
    //     var workrequestid_id = $(this).attr('data-workrequestid');
    //     var status = $(this).attr('data-status');
    //     var applicant = $.ajax({
    //         url: '/applicants-status',
    //         type: 'POST',
    //         data: {'reason': reason,
    //             'company_id': company_id,
    //             'workrequestid': workrequestid_id,
    //             'status': status,
    //         },
    //         headers: {
    //             'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    //         },
    //         // beforeSend: function beforeSend() {
    //         //     btn.text("");
    //         //     //$btn.html('<i class="spinner-border small-icon me-3 d-block "></i>');
    //         // },
    //         success: function (response) {
    //             console.log(response);
    //         },
    //         error: function (error) {
    //             var err = JSON.parse(error.responseText);
    //             toastr.error(err.toastr);
    //         }
    //     });

    // } );

    // $('body').on('click', ".applicant-accept", function (e) {
    //     e.preventDefault();
    //     alert();
    // } );


    if ($('body').hasClass("feed-timeline")){
        getAllTimelinePosts();
    }


    $("body").on('click', '#post-action', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let post_submit_button = $(this);
        let message = $('#message').val();
        $.ajax({
            url: '/post-request',
            type: 'POST',
            data: {
                message: message,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                post_submit_button.prop('disabled', true);
            },
            success: function (response) {
                // toastr.success(response.toastr)
                $('#message').val("");
                getAllTimelinePosts();
            },
            error: function (error) {
                var err = JSON.parse(error.responseText);
                toastr.error(err.toastr);
            },
            complete: function () {
                post_submit_button.prop('disabled', false);
            }
        });
    });

    $("body").on('click', '.post-see-more', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $post_see_more = $(this);
        $post_see_more_id = $post_see_more.attr("data-post-id");
        $post_content_body = $post_see_more.parent();
        $.ajax({
            url: '/see-more',
            type: 'POST',
            data: {
                see_more_id: $post_see_more_id,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                $post_see_more.html("loading....")
            },
            success: function (response) {
                // toastr.success(response.toastr)
                $post_content_body.html(response.content);
            },
            error: function (error) {
            },
            complete: function () {
                $post_see_more.html("See more")
            }
        });
    });

    $("body").on('click', '.action-like', function (e) {
        e.preventDefault();
        $like_btn = $(this);
        $post_id = $like_btn.attr('data-post-id');
        $action = $like_btn.attr("data-action");
        $likeCount = parseInt($like_btn.attr('data-likecount'));

        // console.log($post_id, $action , $likeCount)

        if ($post_id && $action) {
            $.ajax({
                url: '/like-post',
                type: 'POST',
                data: {
                    post_id: $post_id,
                    action: $action,
                    _token: $('meta[name="csrf-token"]').attr('content')
                },
                success: function (response) {
                    if (response.success) {
                        if (response.action == 'add') {

                            $newLikeCount = $likeCount + 1;
                            $like_btn.removeClass('add-like').addClass("remove-like").attr("data-action", "remove").attr("data-likecount", $newLikeCount)
                            $like_btn.find('span').html($newLikeCount + ' Like');
                        } else if (response.action == 'remove') {
                            // console.log('removed')
                            $newLikeCount = $likeCount - 1;
                            $like_btn.removeClass('remove-like').addClass("add-like").attr("data-action", "add").attr("data-likecount", $newLikeCount)
                            $like_btn.find('span').html($newLikeCount + ' Like');
                        }
                    }
                },
                error: function (error) {
                    var err = JSON.parse(error.responseText);
                    toastr.error(err.toastr);
                }
            });
        }


    });


    $("body").on('click', '.post-comment', function (e) {
        e.preventDefault();
        $comment_btn = $(this);
        $post_id = $comment_btn.parent().find('.comment-field').data('post-id');
        $comment_content = $comment_btn.parent().find('.comment-field').val();

        if ($post_id && $comment_content) {
            $.ajax({
                url: '/post-comment',
                type: 'POST',
                data: {
                    post_id: $post_id,
                    content: $comment_content,
                    _token: $('meta[name="csrf-token"]').attr('content')
                },
                success: function (response) {
                    // toastr.success(response.toastr)
                    if (response.success) {

                        $count = $comment_btn.parent().parent().parent().find('.count').text();
                        $count = parseInt($count) + 1;
                        $comment_btn.parent().parent().parent().find('.count').text($count);
                        $comment_btn.parent().parent().parent().find('.user-comment').trigger('click');
                        $comment_btn.parent().find('.comment-field').val("")
                    }
                },
                error: function (error) {
                    var err = JSON.parse(error.responseText);
                    toastr.error(err.message);
                }
            });
        }

    });


    $("body").on('click', '.user-comment', function (e) {
        e.preventDefault();
        $user_btn = $(this);
        $post_id  = $user_btn.data('post-id');

        $.ajax({
            url: '/get-comments',
            type: 'POST',
            data: {
                post_id: $post_id,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                $user_btn.parent().parent().find('.comment-block').html("");
                $user_btn.parent().parent().find('.comment-block').html(response);
            },
            error: function (error) {
                var err = JSON.parse(error.responseText);
                toastr.error(err.message);
            }
        });
    });




    $("body").on('click', '#resend_user_activation_email' , function(e){
        e.preventDefault();
        $resent_button = $(this);
        $user_id = $(this).attr("data-user-id");

        if (!$user_id){
            return;
        }

        $.ajax({
            url: '/email/verification-notification',
            type: 'POST',
            data: {
                user_id: $user_id,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                if (response.success) {
                    toastr.success(response.toastr);
                    $resent_button.parent().html('').html(response.message);
                }else{
                    toastr.error(response.toastr);
                }
            },
            error: function (error) {
                var err = JSON.parse(error.responseText);
                toastr.error(err.message);
            }
        });


    })

});






